import React, { Fragment, useContext, useState } from "react";
import { Context } from "../../../context/globalContext";
import mcatIcon from "../../../assets/images/sprites/mcat-icon.svg";
import stepOneIcon from "../../../assets/images/sprites/step-one-icon.svg";
import stepTwoIcon from "../../../assets/images/sprites/step-two-icon.svg";
import stepThreeIcon from "../../../assets/images/sprites/step-three-icon.svg";
import rightArrowBlack from "../../../assets/images/sprites/right-arrow-black.png";
import styled from "styled-components";
import ScoreModal from "./ScoreModal";

export default function Score() {

  const {
    state: { user: userProfile },
  } = useContext(Context);
  const [mcatModal, setMCATModal] = useState(false);
  const [step1Modal, setStep1Modal] = useState(false);
  const [step2Modal, setStep2Modal] = useState(false);
  const [step3Modal, setStep3Modal] = useState(false);

  function uploadFileMCAT(file) {
    // dispatch(
    //   storageActions.uploadFileAction({
    //     name: `files/${userProfile.email}/MCAT/${file.name}`,
    //     file,
    //   }),
    // );
  }

  function uploadFileStep1(file) {
    // dispatch(
    //   storageActions.uploadFileAction({
    //     name: `files/${userProfile.email}/Step1/${file.name}`,
    //     file,
    //   }),
    // );
  }

  function uploadFileStep2(file) {
    // dispatch(
    //   storageActions.uploadFileAction({
    //     name: `files/${userProfile.email}/Step2/${file.name}`,
    //     file,
    //   }),
    // );
  }

  function uploadFileStep3(file) {
    // dispatch(
    //   storageActions.uploadFileAction({
    //     name: `files/${userProfile.email}/Step3/${file.name}`,
    //     file,
    //   }),
    // );
  }

  return (
    <ScoreContainer>
      <ScoreCard
        title={"MCAT"}
        type={"MCAT"}
        icon={mcatIcon}
        modalIsShow={mcatModal}
        userProfile={userProfile}
        onHideModal={() => setMCATModal(false)}
        uploadFile={uploadFileMCAT}
        value={userProfile.mcat}
        requested={userProfile.mcat_review_requested}
        isPassed={userProfile.is_passed_mcat}
        onSubmit={() => setMCATModal(true)}
        available={
          !userProfile.mcat_review_requested &&
          !userProfile.is_passed_mcat &&
          !userProfile.mcat &&
          !userProfile.mcat_document_name
        }
      />
      <ScoreCard
        title={"Step One"}
        type={"Step One"}
        icon={stepOneIcon}
        modalIsShow={step1Modal}
        userProfile={userProfile}
        onHideModal={() => setStep1Modal(false)}
        uploadFile={uploadFileStep1}
        requested={userProfile.step_1_review_requested}
        value={userProfile.step_1}
        isPassed={userProfile.is_passed_step1}
        onSubmit={() => setStep1Modal(true)}
        available={
          !userProfile.step_1_review_requested &&
          !userProfile.is_passed_step1 &&
          !userProfile.step_1 &&
          !userProfile.step_1_document_name
        }
      />
      <ScoreCard
        title={"Step Two CK/CS"}
        type={"Step Two"}
        icon={stepTwoIcon}
        modalIsShow={step2Modal}
        userProfile={userProfile}
        onHideModal={() => setStep2Modal(false)}
        uploadFile={uploadFileStep2}
        requested={userProfile.step_2_review_requested}
        value={userProfile.step_2}
        isPassed={userProfile.is_passed_step2}
        onSubmit={() => setStep2Modal(true)}
        available={
          !userProfile.step_2_review_requested &&
          !userProfile.is_passed_step2 &&
          !userProfile.step_2 &&
          !userProfile.step_2_document_name
        }
      />
      <ScoreCard
        title={"Step Three"}
        type={"Step Three"}
        icon={stepThreeIcon}
        modalIsShow={step3Modal}
        userProfile={userProfile}
        onHideModal={() => setStep3Modal(false)}
        uploadFile={uploadFileStep3}
        requested={userProfile.step_3_review_requested}
        value={userProfile.step_3}
        isPassed={userProfile.is_passed_step3}
        onSubmit={() => setStep3Modal(true)}
        available={
          !userProfile.step_3_review_requested &&
          !userProfile.is_passed_step3 &&
          !userProfile.step_3 &&
          !userProfile.step_3_document_name
        }
      />
    </ScoreContainer>
  );
}

function ScoreCard(props) {
  return (
    <ScoreCardContainer>
      <ImgContainer>
        <img src={props.icon} alt="" />
        <Title>{props.title}</Title>
      </ImgContainer>
      {props.available ? (
        <>
          <NoScoreAvailable>No score available</NoScoreAvailable>
          <SubmitButton onClick={props.onSubmit}>{"Submit Score"}</SubmitButton>
        </>
      ) : props.requested ? (
        <>
          <WaitGreenText>
            Once we verify your scores, you will see them here.
          </WaitGreenText>
          <WaitingForReview>{"Waiting for review"}</WaitingForReview>
        </>
      ) : (
        <>
          <ScoreText>
            {props.value}
            {props.isPassed && (
              <span style={{ fontSize: "0.6em" }}>{" /Pass"}</span>
            )}
          </ScoreText>
          <SubmitButton onClick={props.onSubmit}>{"Edit Score"}</SubmitButton>
        </>
      )}
      <ScoreModal
        userProfile={props.userProfile}
        isShow={props.modalIsShow}
        onHide={props.onHideModal}
        uploadFile={props.uploadFile}
        type={props.type}
      />
    </ScoreCardContainer>
  );
}

const ScoreContainer = styled.section`
  width: 100%;
  display: flex;
  margin-bottom: 56px;
  justify-content: space-around;
  @media (max-width: 720px) {
    display: none;
  }
`;
const ScoreCardContainer = styled.div`
  width: 25%;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ImgContainer = styled.div`
  height: 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Title = styled.p`
  font-size: 1.5em;
  margin-top: 8px;
  color: ${(props) => props.theme.color.darkGreen};
`;
const NoScoreAvailable = styled.p`
  font-size: 1.3em;
`;
const SubmitButton = styled.button`
  padding: 4px 8px;
  background: none;
  border: none;
  font-size: 1.4em;
  font-weight: bold;
`;
const WaitingForReview = styled.p`
  font-size: 1.4em;
  font-weight: bold;
`;
const WaitGreenText = styled.p`
  color: ${(props) => props.theme.color.darkGreen};
  font-size: 1.4em;
  text-align: center;
`;
const ScoreText = styled.p`
  font-size: 2.8em;
  color: ${(props) => props.theme.color.darkGreen};
  margin-bottom: 8px;
`;
